module.exports = __webpack_public_path__ + "static/media/026.849da0ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/026.jpg
// module id = 373
// module chunks = 0